// @flow
import { FormsActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    form: {},
    listaForms: [],
    loading: false,
    loadingList: false,
    error: false,
    errorList: false,
    formSubmited: false
};

type FormsAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { form?: {} | null, listaForms?: [] | null, loading?: boolean, +value ?: boolean };

const Forms = (state: State = INIT_STATE, action: FormsAction): any => {
    // console.log(action);
    switch (action.type) {
        case FormsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case FormsActionTypes.GET_FORM: {
                    return {
                        ...state,
                        form: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case FormsActionTypes.LIST_FORMS: {
                    return {
                        ...state,
                        listaForms: action.payload.data,
                        errorList: false,
                        loadingList: false,
                    };
                }
                case FormsActionTypes.ADD_FORM: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        // contacto: action.payload.data,
                        formSubmited: true
                    };
                }
                case FormsActionTypes.UPDATE_FORM: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        form: action.payload.data,
                        formSubmited: true
                    };
                }
                case FormsActionTypes.DELETE_FORM: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        // contacto: action.payload.data,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case FormsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case FormsActionTypes.GET_FORM: {
                    return {
                        ...state,
                        error: action.payload.error,
                        form: {},
                        loading: false,
                    };
                }
                case FormsActionTypes.LIST_FORMS: {
                    return {
                        ...state,
                        errorList: true,
                        listaForms: [],
                        loadingList: false,
                    };
                }
                case FormsActionTypes.ADD_FORM: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case FormsActionTypes.UPDATE_FORM: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case FormsActionTypes.DELETE_FORM: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case FormsActionTypes.GET_FORM:
            return { ...state, error: false, loading: true };
        case FormsActionTypes.LIST_FORMS:
            return { ...state, errorList: false, loadingList: true };
        case FormsActionTypes.ADD_FORM:
            return { ...state, error: false, loading: false };
        case FormsActionTypes.UPDATE_FORM:
            return { ...state, error: false, loading: false };
        case FormsActionTypes.DELETE_FORM:
            return { ...state, error: false, loading: false };
        case FormsActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                loadingList: false,
                errorList: false,
                form: {},
                listaForms: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default Forms;
